module.exports = __webpack_public_path__ + "static/media/arrowleft.fb5d08c9.svg";